import type { HttpCore } from '../http';
import type {
  CheckoutRequest,
  CheckoutResponse,
  Paged,
  Payment,
  Invoice,
  Subscription,
  WithdrawalPreview,
  WithdrawalReceipt,
} from '../types';

/** `/api/v1/subscription` — plan state, payment history and the Mollie (or fake) checkout. */
export function createSubscriptionApi(http: HttpCore) {
  return {
    get: () => http.get<Subscription>('/subscription'),
    payments: () => http.get<Paged<Payment>>('/subscription/payments'),
    /** Returns the hosted checkout URL to redirect the browser to. */
    checkout: (body: CheckoutRequest) => http.post<CheckoutResponse>('/subscription/checkout', body),
    cancel: () => http.post<Subscription>('/subscription/cancel'),
    resume: () => http.post<Subscription>('/subscription/resume'),
    /** What ending the contract now would mean. Changes nothing. */
    withdrawalPreview: () => http.get<WithdrawalPreview>('/subscription/withdrawal'),
    /** The "Confirm withdrawal" button. `confirm` must be explicit. */
    withdraw: (body: { confirm: true; reason?: string }) =>
      http.post<WithdrawalReceipt>('/subscription/withdrawal', body),
    /** Every acknowledgement this customer has, so a copy is always retrievable. */
    withdrawals: () => http.get<WithdrawalReceipt[]>('/subscription/withdrawals'),
    /** Invoices and credit notes, newest first. */
    invoices: () => http.get<Invoice[]>('/subscription/invoices'),
    /** The invoice as a PDF, in the customer's language. */
    invoicePdf: (id: string) => http.blob(`/subscription/invoices/${encodeURIComponent(id)}/pdf`),
  };
}

export type SubscriptionApi = ReturnType<typeof createSubscriptionApi>;
